export type DailyMetricFillFilter = 'all' | 'complete' | 'empty'

export const DAILY_METRIC_FILL_FILTER_ORDER: DailyMetricFillFilter[] = ['all', 'complete', 'empty']

export function matchesFillFilter(value: number, filter: DailyMetricFillFilter): boolean {
  if (filter === 'all') return true
  if (filter === 'complete') return value > 0
  return value === 0
}
